export const buildJobApplicationQueryKey = (profileId: number | undefined, jobApplicationId: number) => [
  profileId,
  "job-application",
  jobApplicationId,
];
